const ADMIN_USER_IDS = new Set([
  "90797808-0806-4ac2-93c8-4cf8ca7d994f",
  "b3226249-d04b-409e-8732-524bb1851934",
  "60ddeef4-0710-43fb-8ee6-7edc19617914",
]);

const ADMIN_EMAILS = new Set(["test@gmail.com"]);

export function isProductAdmin(input: {
  id?: string | null;
  email?: string | null;
}): boolean {
  return (
    (input.id != null && ADMIN_USER_IDS.has(input.id)) ||
    (input.email != null && ADMIN_EMAILS.has(input.email))
  );
}
